export default __webpack_public_path__ + "static/media/330_portfolio02-it-mobile.1e94b3a4.png";